/*
Copyright 2025 iodyne.  All rights reserved.
iodyne Proprietary/Confidental: INTERNAL USE ONLY
*/

import { createFileRoute } from '@tanstack/react-router';
import { AuthStates, getAuthState } from '@/lib/auth/auth_state';
import { useTranslation } from '@/i18n/client_hook';
import { defaultNS } from '@/i18n/settings';
import PeopleTeamList from '@/components/controllers/people/PeopleTeamsList';

export const Route = createFileRoute("/_authenticated/people/")({
  component: RouteComponent
})

function RouteComponent() {
  const { t } = useTranslation(defaultNS);
  const org_id = getAuthState(AuthStates.activeOrgID)!;
    
    return <div className="p-6 pt-0">
        <PeopleTeamList />
    </div>
}